import React from 'react';

import { Draggable } from 'react-beautiful-dnd';

import { DragIcon } from '@adsk/alloy-react-icon';

import ColumnOption, { ColumnOptionProps } from './ColumnOption';

type ReorderableColumnOptionProps<D extends Record<string, unknown>> =
  ColumnOptionProps<D> & {
    id: string;
    index: number;
  };

const ReoderableColumnOption = <D extends Record<string, unknown>>({
  id,
  index,
  column,
  ...props
}: ReorderableColumnOptionProps<D>) => {
  return (
    <Draggable key={id} draggableId={id} index={index}>
      {(provided) => (
        <ColumnOption
          ref={provided.innerRef}
          data-testid={`TableConfigurationMenu__ColumnOption-${index}`}
          column={column}
          {...props}
          {...provided.draggableProps}
        >
          <div
            data-testid={`TableConfigurationMenu__ColumnOption-${index}__DragHandle`}
            style={{ display: 'flex', alignItems: 'center' }}
            {...provided.dragHandleProps}
          >
            <DragIcon style={{ marginRight: 8 }} />
          </div>
        </ColumnOption>
      )}
    </Draggable>
  );
};

export default ReoderableColumnOption;
